import jsQR from 'jsqr'
import jpeg from 'jpeg-js'

function base64ToByteArray (url) {
  let splitData = url.split(',')

  let base64Data = splitData.length === 2 ? splitData[1] : splitData

  return Buffer.from(base64Data, 'base64')
}

export default async (dataURL) => {
  let binaryArray = base64ToByteArray(dataURL)

  let imagePixelData = jpeg.decode(binaryArray)

  let code = jsQR(imagePixelData.data, imagePixelData.width, imagePixelData.height)

  return code ? code.data : null
}
